// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__37NzM","dragIcon":"SortableItem_dragIcon__3gn9D","disabled":"SortableItem_disabled__278ej"};